const getNextSearchLightLikeState = (game, actionType, payload) => {
  if (!game || !payload || String(game.id) !== String(payload.gameId)) return game;

  const prevLikedUsers = Array.isArray(game.likedUsers) ? game.likedUsers : [];
  const prevCount = game.likeCount != null
    ? game.likeCount
    : game.likedNumber != null
      ? game.likedNumber
      : prevLikedUsers.length;

  if (actionType === 'LIKE_SEARCHLIGHT_GAME_SUCCESS') {
    const currentUser = payload.currentUser;
    const currentUserId = currentUser && currentUser.id;
    if (!currentUserId) return game;

    const exists = prevLikedUsers.some(user => String(user.id) === String(currentUserId));
    return {
      ...game,
      likedUsers: exists ? prevLikedUsers : [...prevLikedUsers, { id: currentUserId, ...currentUser }],
      likeCount: exists ? prevCount : prevCount + 1,
    };
  }

  const currentUserId = payload.currentUserId;
  if (!currentUserId) return game;
  const nextLikedUsers = prevLikedUsers.filter(user => String(user.id) !== String(currentUserId));
  return {
    ...game,
    likedUsers: nextLikedUsers,
    likeCount: nextLikedUsers.length < prevLikedUsers.length && prevCount > 0 ? prevCount - 1 : prevCount,
  };
};

const home = (state = {}, action) => {
  switch (action.type) {
    case 'GET_OPTIMIZED_ALL_QUESTS_PENDING':
      return {
        ...state,
        quests: {
          ...state.quests,
          all: {
            ...state.quests.all,
            isLoading: true,
            errors: {
              ...state.quests.all.errors,
              hasError: false,
              code: '',
              message: '',
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ALL_QUESTS_ERROR':
      return {
        ...state,
        quests: {
          ...state.quests,
          all: {
            ...state.quests.all,
            isLoading: false,
            errors: {
              ...state.quests.all.errors,
              hasError: action.payload.error,
              code: action.payload.code,
              message: action.payload.message,
              all: action.payload.errors,
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ALL_QUESTS_ABORTED':
      return {
        ...state,
        quests: {
          ...state.quests,
          all: {
            ...state.quests.all,
            isLoading: false,
            errors: {
              ...state.quests.all.errors,
              hasError: false,
              code: '',
              message: '',
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ALL_QUESTS_SUCCESS':
      return {
        ...state,
        quests: {
          ...state.quests,
          all: {
            ...state.quests.all,
            isLoading: false,
            data: action.payload.response.data,
            total: action.payload.response.total,
            page: action.payload.response.page,
            errors: {
              ...state.quests.all.errors,
              hasError: false,
              code: '',
              message: '',
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ENDED_QUESTS_PENDING':
      return {
        ...state,
        quests: {
          ...state.quests,
          ended: {
            ...state.quests.ended,
            isLoading: true,
            errors: {
              ...state.quests.ended.errors,
              hasError: false,
              code: '',
              message: '',
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ENDED_QUESTS_ERROR':
      return {
        ...state,
        quests: {
          ...state.quests,
          ended: {
            ...state.quests.ended,
            isLoading: false,
            errors: {
              ...state.quests.ended.errors,
              hasError: action.payload.error,
              code: action.payload.code,
              message: action.payload.message,
              all: action.payload.errors,
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ENDED_QUESTS_ABORTED':
      return {
        ...state,
        quests: {
          ...state.quests,
          ended: {
            ...state.quests.ended,
            isLoading: false,
            errors: {
              ...state.quests.ended.errors,
              hasError: false,
              code: '',
              message: '',
            },
          },
        },
      };

    case 'GET_OPTIMIZED_ENDED_QUESTS_SUCCESS':
      return {
        ...state,
        quests: {
          ...state.quests,
          ended: {
            ...state.quests.ended,
            isLoading: false,
            data: action.payload.response.data,
            total: action.payload.response.total,
            page: action.payload.response.page,
            errors: {
              ...state.quests.ended.errors,
              hasError: false,
              code: '',
              message: '',
            },
          },
        },
      };

    case 'GET_SEARCHLIGHT_GAMES_PENDING':
      return {
        ...state,
        searchLight: {
          ...state.searchLight,
          isLoading: action.payload && action.payload.showLoading === false ? state.searchLight.isLoading : true,
          errors: action.payload && action.payload.showLoading === false
            ? state.searchLight.errors
            : {
              ...state.searchLight.errors,
              hasError: false,
              code: '',
              message: '',
              all: {},
            },
        },
      };

    case 'GET_SEARCHLIGHT_GAMES_ERROR':
      return {
        ...state,
        searchLight: {
          ...state.searchLight,
          isLoading: false,
          data: [],
          errors: {
            ...state.searchLight.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_SEARCHLIGHT_GAMES_ABORTED':
    case 'GET_SEARCHLIGHT_GAMES_CANCELED':
      return {
        ...state,
        searchLight: {
          ...state.searchLight,
          isLoading: false,
        },
      };

    case 'GET_SEARCHLIGHT_GAMES_SUCCESS': {
      const data = action.payload && action.payload.response && action.payload.response.data;
      const list = Array.isArray(data && data.games) ? data.games : Array.isArray(data) ? data : [];
      return {
        ...state,
        searchLight: {
          ...state.searchLight,
          isLoading: false,
          data: list,
          errors: {
            ...state.searchLight.errors,
            hasError: false,
            code: '',
            message: '',
            all: {},
          },
        },
      };
    }

    case 'GET_SEARCHLIGHT_GAME_INFO_PENDING':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLoading: true,
          isLikeUpdating: false,
          errors: {
            ...state.searchLightGameInfo.errors,
            hasError: false,
            code: '',
            message: '',
            all: {},
          },
        },
      };

    case 'GET_SEARCHLIGHT_GAME_INFO_ERROR':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLoading: false,
          isLikeUpdating: false,
          data: null,
          errors: {
            ...state.searchLightGameInfo.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'GET_SEARCHLIGHT_GAME_INFO_ABORTED':
    case 'GET_SEARCHLIGHT_GAME_INFO_CANCELED':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLoading: false,
          isLikeUpdating: false,
        },
      };

    case 'GET_SEARCHLIGHT_GAME_INFO_SUCCESS':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLoading: false,
          isLikeUpdating: false,
          data: action.payload && action.payload.response ? action.payload.response.game : null,
          errors: {
            ...state.searchLightGameInfo.errors,
            hasError: false,
            code: '',
            message: '',
            all: {},
          },
        },
      };

    case 'LIKE_SEARCHLIGHT_GAME_PENDING':
    case 'UNLIKE_SEARCHLIGHT_GAME_PENDING':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLikeUpdating: true,
          errors: {
            ...state.searchLightGameInfo.errors,
            hasError: false,
            code: '',
            message: '',
            all: {},
          },
        },
      };

    case 'LIKE_SEARCHLIGHT_GAME_ERROR':
    case 'UNLIKE_SEARCHLIGHT_GAME_ERROR':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLikeUpdating: false,
          errors: {
            ...state.searchLightGameInfo.errors,
            hasError: action.payload.error,
            code: action.payload.code,
            message: action.payload.message,
            all: action.payload.errors,
          },
        },
      };

    case 'LIKE_SEARCHLIGHT_GAME_ABORTED':
    case 'LIKE_SEARCHLIGHT_GAME_CANCELED':
    case 'UNLIKE_SEARCHLIGHT_GAME_ABORTED':
    case 'UNLIKE_SEARCHLIGHT_GAME_CANCELED':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLikeUpdating: false,
        },
      };

    case 'LIKE_SEARCHLIGHT_GAME_SUCCESS':
    case 'UNLIKE_SEARCHLIGHT_GAME_SUCCESS':
      return {
        ...state,
        searchLightGameInfo: {
          ...state.searchLightGameInfo,
          isLikeUpdating: false,
          data: getNextSearchLightLikeState(
            state.searchLightGameInfo && state.searchLightGameInfo.data,
            action.type,
            action.payload,
          ),
          errors: {
            ...state.searchLightGameInfo.errors,
            hasError: false,
            code: '',
            message: '',
            all: {},
          },
        },
      };

    default:
      return state;
  }
};

export default home;
